import React from "react";
import { assest } from "../Assest/Assest";

function Gallery() {
  // Dynamically get all gallery images
  const galleryImages = Object.keys(assest)
    .filter((key) => key.startsWith("img")) // Filter for image keys
    .map((key) => assest[key]); // Get image paths

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: "20px",
        padding: "20px",
        backgroundColor: "#CADCFC",
      }}
    >
      {galleryImages.map((image, index) => (
        <div
          key={index}
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0px 6px 10px rgba(0, 36, 107, 0.2)",
            transition: "transform 0.3s, box-shadow 0.3s",
          }}
          className="gallery-item"
        >
          <img
            src={image}
            alt={`Gallery ${index + 1}`}
            style={{
              width: "100%",
              height: "auto",
              display: "block",
              transition: "transform 0.3s",
            }}
            className="gallery-image"
          />
        </div>
      ))}

      {/* Inline styles for hover effect */}
      <style jsx>{`
        .gallery-item:hover {
          transform: translateY(-10px);
          box-shadow: 0px 10px 15px rgba(0, 36, 107, 0.3);
        }
        .gallery-item img:hover {
          transform: scale(1.05);
        }
      `}</style>
    </div>
  );
}

export default Gallery;
